module.exports = __webpack_public_path__ + "img/LsgAudio19-23.738a1b28.jpeg";